import { createAction } from '@ngrx/store';

export class DarwinActions {

  static readonly moduleInitialized =
    createAction('[Darwin Module] Initialized');

}
